import React from 'react';
import PropTypes from 'prop-types';
import MaterialTableContainer from '@material-ui/core/TableContainer';
import '../styles/TableContainer.scss';

const TableContainer = (props) => {
    let className = 'table-container';
    if (props.responsive) {
        className += ' table-responsive';
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <MaterialTableContainer className={className}>{props.children}</MaterialTableContainer>
    );
};

TableContainer.propTypes = {
    className: PropTypes.string,
    responsive: PropTypes.bool,
};

TableContainer.defaultProps = {
    responsive: false,
};

export default TableContainer;
